import { render, staticRenderFns } from "./VerticalField.vue?vue&type=template&id=c380fcce&"
import script from "./VerticalField.vue?vue&type=script&lang=js&"
export * from "./VerticalField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports